import { client } from '../../../core/api/client';

export const ACCOUNTS_BASE_API_ENDPOINT = '/api/v1/accounts';

export interface StagingPasswordRequest {
  stagingPassword: string;
}

export interface StagingPasswordSuccessResponse {
  statusCode: number;
  message: string;
  status: string;
  isValid: boolean;
}

export interface StagingPasswordErrorResponse {
  error: {
    statusCode: number;
    name: string;
    message: string;
  };
}

export const postStagingPassword = (payload: StagingPasswordRequest, signal?: AbortSignal) => {
  return client.post<StagingPasswordSuccessResponse>(
    `${ACCOUNTS_BASE_API_ENDPOINT}/member/password-staging-protection`,
    payload,
    { signal }
  );
};
